<template>
  <section>
    <template v-if="titlePrefix">
      <h1 class="d-none d-md-block">
        {{ titlePrefix }}
      </h1>
      <h2 class="d-block d-md-none">
        {{ titlePrefix }}
      </h2>
      <h5>
        {{ $t('message.onBoarding.buildings.address') }}:
        <address-text
          :one-line="true"
          :address="object.address" />
      </h5>
    </template>
    <template v-else>
      <h1 class="d-none d-md-block">
        <address-text
          :one-line="true"
          :address="object.address" />
      </h1>
      <h2 class="d-block d-md-none">
        <address-text
          :one-line="true"
          :address="object.address" />
      </h2>
    </template>
    <h5>
      <template v-if="titlePrefix">
        <span>{{ object.publicId }}</span>
        <span v-if="object.name"> | {{ object.name | displayOptionalValue }}</span>
        <span v-if="showMarketingStatus">
          | {{ $t('message.marketingObjects.status.title') }}:
          <span :class="statusColor">{{ statusTitle }}</span>
          <span
            v-if="statusFutureDate"
            :class="statusColor">
            {{ $t('message.generic.until') + ' ' + statusFutureDate }}
          </span>
          <span
            v-else-if="statusDate"
            :class="statusColor">
            {{ $t('message.generic.since') + ' ' + statusDate }}
          </span>
        </span>
      </template>
      <template v-else>
        <span>{{ object.publicId }} | </span>
        <span v-if="getObjectRoom(object) > 0">{{ formatRooms(getObjectRoom(object)) }} </span>
        <span>{{ $t('message.onBoarding.buildings.objects.category.' + object.category.toLowerCase()) }} </span>
        <span v-if="getObjectFloor(object) > -10000">{{ formatFloor(getObjectFloor(object)) }}</span>
        <span v-if="showMarketingStatus">
          | {{ $t('message.marketingObjects.status.title') }}:
          <span :class="statusColor">{{ statusTitle }}</span>
          <span
            v-if="statusFutureDate"
            :class="statusColor">
            {{ $t('message.generic.until') + ' ' + statusFutureDate }}
          </span>
          <span
            v-else-if="statusDate"
            :class="statusColor">
            {{ $t('message.generic.since') + ' ' + statusDate }}
          </span>
        </span>
      </template>
      <coozzy-alert
        v-if="showMarketingInfoBox && object.marketingStatus && object.marketingStatus.marketingNote"
        class="my-2"
        variant="blue"
        size="sm">
        <div>
          <h6 class="d-inline-block alert-heading font-weight-bold mb-0">
            {{ $t('message.marketingObjects.startMarketing') }}:
          </h6>
          {{ object.marketingStatus.startMarketingAt | timestampToDate }}
        </div>
        <h6 class="alert-heading font-weight-bold mb-0 mt-2">
          {{ $t('message.marketingObjects.marketingNote') }}:
        </h6>
        <div
          v-if="object.marketingStatus.marketingNote.length < 60 ">
          {{ object.marketingStatus.marketingNote }}
        </div>
        <div
          v-else-if="!marketingNoteVisibility">
          {{ object.marketingStatus.marketingNote.substring(0, 20) }}...
          <b-link
            @click="showMoreShowLess">
            {{ $t('message.generic.showMore') }}
          </b-link>
        </div>
        <div
          v-else>
          <b-collapse
            id="collapse-1"
            v-model="marketingNoteVisibility">
            <p>{{ object.marketingStatus.marketingNote }}</p>
          </b-collapse>
          <b-link
            @click="showMoreShowLess">
            {{ $t('message.generic.showLess') }}
          </b-link>
        </div>
      </coozzy-alert>
    </h5>
  </section>
</template>
<script>
import AddressText from '../framework/components/misc/AddressText'
import { obj } from '@/mixins/object'
import { formatting } from '@/mixins/formatting'
import CoozzyAlert from '@/framework/components/alert/CoozzyAlert'

export default {
  name: 'TitleMarketingObjectView',
  components: {
    CoozzyAlert,
    AddressText
  },
  mixins: [formatting, obj],
  props: {
    object: {
      type: Object,
      default: null
    },
    showMarketingInfoBox: {
      type: Boolean,
      default: true
    },
    showMarketingStatus: {
      type: Boolean,
      default: true
    },
    titlePrefix: {
      type: String,
      default: ''
    }
  },
  computed: {
    statusTitle() {
      return this.calculateMarketingStatus(this.object.marketingStatus).label
    },
    statusColor() {
      return this.calculateMarketingStatus(this.object.marketingStatus).color
    },
    statusDate() {
      return this.calculateMarketingStatus(this.object.marketingStatus).date
    },
    statusFutureDate() {
      return this.calculateMarketingStatus(this.object.marketingStatus).dateFuture
    }
  },
  methods: {
    showMoreShowLess() {
      this.marketingNoteVisibility = !this.marketingNoteVisibility
    }
  }
}
</script>
